import { CurrentUserService } from 'src/app/core/services/current-user.service';
import { Component, OnInit, Inject } from '@angular/core';
import { ModalService } from 'src/app/shared/services/modal.service';
import { MAT_DIALOG_DATA } from '@angular/material';
import { AppNotificationService } from 'src/app/shared/services/app-notification.service'

declare const ga: any;

@Component({
    selector: 'announcement-popup',
    templateUrl: './announcement-popup.component.html',
    styleUrls: ['./announcement-popup.component.sass']
})
export class AnnouncementPopupComponent implements OnInit {
    public announcement:any;
    private notification:any;

    constructor(
        @Inject(MAT_DIALOG_DATA) public data: any,
        private modal: ModalService,
        private appNotyService: AppNotificationService,
        public currentUserService: CurrentUserService
    ) {
        this.announcement = data.announcement
        this.notification = data.notification
    }

    ngOnInit() { }

    public markRead() {
        let notifications = this.appNotyService.notifications.value
        for (let i = 0; i < notifications.length; i += 1) {
            if (notifications[i]._id === this.notification._id) {
                notifications[i].notificationContent.unread = false;
            }
        }
        this.appNotyService.notificationHandler({ eventName: "read_one", data: this.notification, updatedNotifications: notifications })
        this.close()
    }

    /**
     * Close modal
     */
    public close() {
        // Clear high priority notificaions
        this.appNotyService.clearHighPriorityNotifications('general');
        this.modal.close();
    }
}
